import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment"
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class NotificationSettingsService {

  constructor(private http:HttpClient) { }

  saveQueue(result:any) {
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/common/NotificationSettings/save",result,{observe:"response"});
   }
   
   deleteQueue(result: any) {
    let headers = new HttpHeaders();
    return this.http.delete(environment.API_URL + "/api/common/deleteNotificationSettings/"+result, {
        observe: "response"
    });
}

   getQueueList(request:{page:any,size:any},search:{searchText:any,userType:any}) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
        httpParam=httpParam.append("page", request.page);
        httpParam=httpParam.append("size", request.size);
        httpParam=httpParam.append("searchText", search.searchText);

      return this.http.get( environment.API_URL+"/api/common/NotificationSettings" ,{ observe : "body", params : httpParam,responseType : "json"})
   
  }
  QueueAlllist() {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.get( environment.API_URL+"/api/common/getAllNotificationSettings" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }

  

}
